import _WidgetBaseSP from 'more/_WidgetBaseSP';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './FurtherAddressessInfoDataForm.html?raw';
import SelectBox from '../../../moreCore/UI/SelectBox/SelectBox';
import GenericDialog from '../../../moreCore/UI/GenericDialog/GenericDialog';
import HintBox from '../../../moreCore/UI/EntityBased/HintBox/HintBox';
import SearchSelect from '../../../moreCore/UI/SearchSelect/SearchSelect';
import Edit from '../../../moreCore/UI/Edit/Edit';

class FurtherAddressessInfoDataForm extends compose(_WidgetBaseSP) {
    templateString: any = template;
    isReadonly: boolean = false;
    isDirty: boolean = false;

    formData: IndividualData_FurtherAddressessSave = {
        is_new: null,
        ID: "",
        description: "",
        street: "",
        postal_code_id: "",
        postal_code: "",
        city: "",
        country: "",
        phone: "",
        mobile_phone: "",
        email: ""
    };
    originalData: string = "";
    allAddresses: Array<IndividualData_FurtherAddressessInfo>;

    addressSelect: MdsLax<InstanceType<typeof SelectBox>>;

    DescriptionInput: MdsLax<InstanceType<typeof Edit>>;
    StreetInput: MdsLax<InstanceType<typeof Edit>>;
    PostalCodeInput: MdsLax<InstanceType<typeof Edit>>;
    CityInput: MdsLax<InstanceType<typeof Edit>>;
    CountryInput: MdsLax<InstanceType<typeof SearchSelect>>;;
    PhoneInput: MdsLax<InstanceType<typeof Edit>>;
    MobileInput: MdsLax<InstanceType<typeof Edit>>;
    EmailInput: MdsLax<InstanceType<typeof Edit>>;

    PostalCodeHintBox: MdsLax<InstanceType<typeof HintBox>>;
    postalCodeSectionMessageContainer: HTMLElement;

    furtherAddressDataFormErrorContainer: HTMLElement;
    furtherAddressDataFormErrorMessage: HTMLElement;

    loadFormData(data: Array<IndividualData_FurtherAddressessInfo>): void {

        data.length > 0 ? this.addressSelect.setPlaceholder(this.translations["FormLabel_AllFurtherAddresses_Placeholder"]) : this.addressSelect.setPlaceholder(this.translations["FormLabel_AllFurtherAddresses_Placeholder_empty"]);
        this.allAddresses = data;

        this.addressSelect.clear();

        data.forEach(address => {

            let label = `${address.description}`;
            if (address.is_active === false) label = `${label} (INAKTIV)`
            this.addressSelect.addOption(address.ID, label);
        });
        this.addressSelect.addOption("add_new_address", this.translations["FormLabel_AllFurtherAddresses_addNewAddress"]);

        this.addressSelect.constructOptions();
        if (this.addressSelect.entries.length > 0) this.addressSelect.setValue(this.addressSelect.entries[0].value);

    }

    clearFormData(): void {
        this.formData = {
            is_new: null,
            ID: "",
            description: "",
            street: "",
            postal_code_id: "",
            postal_code: "",
            city: "",
            country: "",
            phone: "",
            mobile_phone: "",
            email: ""
        };
    }

    _onChange_SelectedAddress(): void {

        let value = this.addressSelect.getValue();
        let data: IndividualData_FurtherAddressessInfo = null; 

        this.clearFormData();
        this.originalData = "";

        if (value === "add_new_address") {
                        
            this.formData.is_new = true;
            this.formData.ID = "";
        } else {

            data = this.allAddresses.filter(x => x.ID === value)[0];
            this.formData.is_new = false;
            this.formData.ID = data.ID;
        }

        this.EmailInput.pattern = `^(([^<>()[\\]\\.,;:\\s@\\"]+(\\.[^<>()[\\]\\.,;:\\s@\\"]+)*)|(\\".+\\"))@(([^<>()[\\]\\.,;:\\s@\\"]+\\.)+[^<>()[\\]\\.,;:\\s@\\"]{2,})$`;
        this.PostalCodeHintBox._setPlaceholderAttr(this.translations["FormLabel_PostalCode_HintBox_Placeholder"]);

        this.serializeFormData(data);

        if (data) {

            this.DescriptionInput.setValue(data.description, true);
            this.StreetInput.setValue(data.street, true);

            if (data.ref_postal_code) {

                this.PostalCodeInput.setValue(data.ref_postal_code.postal_code, true);
                this.CityInput.setValue(data.ref_postal_code.city, true);

                this.CountryInput.loadListValues(data.ref_postal_code.ref_country.ID, true);
            } else {

                this.PostalCodeInput.setValue(data.c_postal_code, true);
                this.CityInput.setValue(data.c_city, true);

                this.CountryInput.loadListValues(data.ref_country, true);
            }
            //this.PostalCodeInput.setReadonly(true);
            //this.CityInput.setReadonly(true);
            this.UiModder.domClass.add(this.PostalCodeInput.inputNode, "w3-disabled");
            this.UiModder.domClass.add(this.CityInput.inputNode, "w3-disabled");
            this.CountryInput._setReadonlyAttr(true);

            this.PhoneInput.setValue(data.ref_vw_telecom_addresses.phonenumber, true);
            this.MobileInput.setValue(data.ref_vw_telecom_addresses.mobilenumber, true);
            this.EmailInput.setValue(data.ref_vw_telecom_addresses.emailaddress, true);

            this.PostalCodeHintBox.setValue(data.ref_postal_code, true);
        } else {

            this.DescriptionInput.setValue(null, true);
            this.StreetInput.setValue(null, true);

            this.PostalCodeInput.setValue(null, true);
            this.CityInput.setValue(null, true);

            this.CountryInput.loadListValues(null, true);

            //this.PostalCodeInput.setReadonly(true);
            //this.CityInput.setReadonly(true);
            this.UiModder.domClass.remove(this.PostalCodeInput.inputNode, "w3-disabled");
            this.UiModder.domClass.remove(this.CityInput.inputNode, "w3-disabled");
            this.CountryInput._setReadonlyAttr(true);

            this.PhoneInput.setValue(null, true);
            this.MobileInput.setValue(null, true);
            this.EmailInput.setValue(null, true);

            this.PostalCodeHintBox.setValue(null, true);

            this.serializeFormData();
        }

        this.originalData = JSON.stringify(this.formData);

        console.debug(this.originalData);
    }

    serializeFormData(data?: IndividualData_FurtherAddressessInfo): void {

        data ? this.formData.description = data.description : this.formData.description = this.DescriptionInput.getValue();
        data ? this.formData.street = data.street : this.formData.street = this.StreetInput.getValue();
        data ? this.formData.phone = data.ref_vw_telecom_addresses.phonenumber : this.formData.phone = this.PhoneInput.getValue();
        data ? this.formData.mobile_phone = data.ref_vw_telecom_addresses.mobilenumber : this.formData.mobile_phone = this.MobileInput.getValue();

        if (data) {

            this.formData.email = data.ref_vw_telecom_addresses.emailaddress.toLowerCase();
        } else {

            let email: string = this.EmailInput.getValue();
            email ? this.formData.email = email.toLowerCase() : this.formData.email = "";
        }

        //data ? this.formData.postal_code = data.postal_code.postal_code : this.formData.postal_code = this.PostalCodeInput.getValue();
        //data ? this.formData.city = data.postal_code.city : this.formData.city = this.CityInput.getValue();
        //data ? this.formData.country = data.postal_code.ref_country.ID : this.formData.country = this.CountryInput.getValue();

        if (data) {

            if (data.ref_postal_code) {

                this.formData.postal_code_id = data.ref_postal_code.ID;
                this.formData.postal_code = data.ref_postal_code.postal_code;
                this.formData.city = data.ref_postal_code.city;
                this.formData.country = data.ref_postal_code.ref_country.ID;
            } else {

                this.formData.postal_code_id = "";
                this.formData.postal_code = data.c_postal_code;
                this.formData.city = data.c_city;
                this.formData.country = data.ref_country.ID;
            }
        } else {

            let postalCode: string | IndividualData_PostalCode = this.PostalCodeHintBox.getValue();

            switch (typeof (postalCode)) {
                case "object":

                    if (postalCode === null) this.formData.postal_code_id = "";
                    else this.formData.postal_code_id = postalCode.ID;
                    break;
                default:

                    this.formData.postal_code_id = "";
                    break;
            }

            this.formData.postal_code = this.PostalCodeInput.getValue();
            this.formData.city = this.CityInput.getValue();
            this.formData.country = this.CountryInput.getValue();
        }


        console.debug("SERIALIZE DATA", this.formData);
        this.checkDirty();
        //console.debug("isDirty:", this.isDirty);

        if (this.isValid()) this.showErrorMessage(false);
    }

    isValid(): boolean {

        if (this.DescriptionInput.validateInput() === false) return false;
        if (this.StreetInput.validateInput() === false) return false;
        if (this.PostalCodeInput.validateInput() === false) return false;
        if (this.CityInput.validateInput() === false) return false;
        if (this.CountryInput.validateInput() === false) return false;
        if (this.PhoneInput.validateInput() === false) return false;
        if (this.MobileInput.validateInput() === false) return false;
        if (this.EmailInput.validateInput() === false) return false;

        return true;
    }

    checkDirty(): void {

        this.isDirty = JSON.stringify(this.formData) !== this.originalData && this.originalData !== "";

        this.emit("change_isDirty", this.isDirty);
    }

    _onChangePostalCodeHintBox(evt: any): void {

        let hintboxValue = this.PostalCodeHintBox.getValue();

        switch (typeof (hintboxValue)) {
            case "object":

                //this.PostalCodeInput.setReadonly(true);
                //this.CityInput.setReadonly(true);
                this.UiModder.domClass.add(this.PostalCodeInput.inputNode, "w3-disabled");
                this.UiModder.domClass.add(this.CityInput.inputNode, "w3-disabled");
                this.CountryInput._setReadonlyAttr(true);

                this.UiModder.domClass.add(this.postalCodeSectionMessageContainer, "w3-hide");
                this.UiModder.domClass.remove(this.PostalCodeInput.inputNode, "w3-pale-yellow");
                this.UiModder.domClass.remove(this.CityInput.inputNode, "w3-pale-yellow");
                //this.UiModder.domClass.remove(this.CountryInput.outerInput, "w3-pale-yellow");

                let postalCode: IndividualData_PostalCode = this.PostalCodeHintBox.getValue();

                this.PostalCodeInput.setValue(postalCode.postal_code, true);
                this.CityInput.setValue(postalCode.city, true);
                this.CountryInput.setValue(postalCode.ref_country.ID, true);

                break;
            default:

                if (this.PostalCodeHintBox.getValue("entity") !== null && this.PostalCodeHintBox.getValue("value") !== null) {

                    //this.PostalCodeInput.setReadonly(false);
                    //this.CityInput.setReadonly(false);
                    this.UiModder.domClass.remove(this.PostalCodeInput.inputNode, "w3-disabled");
                    this.UiModder.domClass.remove(this.CityInput.inputNode, "w3-disabled");
                    this.CountryInput._setReadonlyAttr(false);

                    this.UiModder.domClass.remove(this.postalCodeSectionMessageContainer, "w3-hide");
                    this.UiModder.domClass.add(this.PostalCodeInput.inputNode, "w3-pale-yellow");
                    this.UiModder.domClass.add(this.CityInput.inputNode, "w3-pale-yellow");
                    //this.UiModder.domClass.add(this.CountryInput.outerInput, "w3-pale-yellow");
                }
                break;
        }

        this.serializeFormData();
    }

    _onChangeAddressDataInput(ev): void {

        this.serializeFormData();
    }

    _onClick_saveBtn(): void {

        if (this.isValid()) {

            let requestUrl = window.appRoot + "IndividualDataSheet/SaveFormData";
            this.StandbyStart();

            this.RequestManager.post(
                requestUrl,
                {
                    jsonData: JSON.stringify(this.formData),
                    sectionName: IndividualData_SectionName.FurtherAddressen
                },
                lang.hitch(this, this._onSaveFormDataResponse),
                lang.hitch(this, this._onSaveFormDataError),
                false // sync
            );
        } else {

            this.showErrorMessage(true, this.translations["IndividualDataSheet_ContactData_DataNotValid"]);
        }
    }

    _onSaveFormDataResponse(): void {

        this.StandbyStop();

        let dlg = new GenericDialog();

        dlg.destroyOnClose = true;
        this.UiModder.domStyle.set(dlg.modalDlgContentNode, "width", "600px");
        this.UiModder.domStyle.set(dlg.modalDlgContentNode, "margin-top", "100px");
        //this.UiModder.domClass.add(dlg.modalDlgContentNode, "w3-round");
        //this.UiModder.domStyle.set(dlg.textNode, "min-height", "150px");
        //this.UiModder.domClass.replace(dlg.headerBarNode, "mds-bg-orange", "secondaryBG");
        //this.UiModder.domClass.add(dlg.textNode, "w3-padding-64 w3-container w3-center");

        dlg.show(this.translations["FormDialog_Save_Message"], this.translations["FormDialog_Save_Header"], null, "fas fa-info-circle", "ok");

        this.emit("DataForm_close");
    }

    //ERRORS
    _onSaveFormDataError(err): void {

        this.StandbyStop();

        this.showErrorMessage(true, err.Message);
    }

    showErrorMessage(bool: boolean, msg?: string) {

        if (bool) {

            this.UiModder.domClass.remove(this.furtherAddressDataFormErrorContainer, "w3-hide");
            msg ? this.furtherAddressDataFormErrorMessage.innerHTML = msg : this.furtherAddressDataFormErrorMessage.innerHTML = "...error occured";
        } else {

            this.UiModder.domClass.add(this.furtherAddressDataFormErrorContainer, "w3-hide");
            this.furtherAddressDataFormErrorMessage.innerHTML = "";
        }
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(FurtherAddressessInfoDataForm);